var _circle, _path, _circle2, _circle3, _path2, _circle4, _circle5, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGroupsFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 3.5,
  r: 2,
  stroke: "#1C1C1A"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  stroke: "#1C1C1A",
  d: "M8 6c-1.933 0-3.5 1.79-3.5 4h7c0-2.21-1.567-4-3.5-4Z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 8.5,
  r: 3,
  fill: "#fff",
  stroke: "#fff"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 8.5,
  r: 2,
  fill: "#fff",
  stroke: "#1C1C1A"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  stroke: "#1C1C1A",
  d: "M4.5 11C2.567 11 1 12.79 1 15h7c0-2.21-1.567-4-3.5-4Z"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 8.5,
  r: 3,
  fill: "#fff",
  stroke: "#fff"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 8.5,
  r: 2,
  fill: "#fff",
  stroke: "#1C1C1A"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  stroke: "#1C1C1A",
  d: "M11.5 11C9.567 11 8 12.79 8 15h7c0-2.21-1.567-4-3.5-4Z"
})));
export { SvgGroupsFilled as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjMuNSIgcj0iMiIgc3Ryb2tlPSIjMUMxQzFBIi8+CjxwYXRoIGQ9Ik04IDZDNi4wNjcgNiA0LjUgNy43OTA4NiA0LjUgMTBIMTEuNUMxMS41IDcuNzkwODYgOS45MzMgNiA4IDZaIiBmaWxsPSIjMUMxQzFBIiBzdHJva2U9IiMxQzFDMUEiLz4KPGNpcmNsZSBjeD0iNC41IiBjeT0iOC41IiByPSIzIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJ3aGl0ZSIvPgo8Y2lyY2xlIGN4PSI0LjUiIGN5PSI4LjUiIHI9IjIiIGZpbGw9IndoaXRlIiBzdHJva2U9IiMxQzFDMUEiLz4KPHBhdGggZD0iTTQuNSAxMUMyLjU2NyAxMSAxIDEyLjc5MDkgMSAxNUg4QzggMTIuNzkwOSA2LjQzMyAxMSA0LjUgMTFaIiBmaWxsPSIjMUMxQzFBIiBzdHJva2U9IiMxQzFDMUEiLz4KPGNpcmNsZSBjeD0iMTEuNSIgY3k9IjguNSIgcj0iMyIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiLz4KPGNpcmNsZSBjeD0iMTEuNSIgY3k9IjguNSIgcj0iMiIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzFDMUMxQSIvPgo8cGF0aCBkPSJNMTEuNSAxMUM5LjU2NyAxMSA4IDEyLjc5MDkgOCAxNUgxNUMxNSAxMi43OTA5IDEzLjQzMyAxMSAxMS41IDExWiIgZmlsbD0iIzFDMUMxQSIgc3Ryb2tlPSIjMUMxQzFBIi8+Cjwvc3ZnPgo=";